import type { ReactNode } from 'react';
import { useAuth } from '../../auth/AuthProvider.js';
import { Boton, Estado, Tarjeta } from '../../components/ui.js';
import { env } from '../../lib/env.js';
import './login.css';

export function LoginPage(): ReactNode {
  const { signInWithGoogle, status, error } = useAuth();

  if (status === 'unconfigured') {
    return (
      <div className="entrada">
        <div className="entrada__caja">
          <Tarjeta
            tono="peligro"
            titulo="Falta configuración"
            descripcion="No hay conexión con el servidor configurada en este dispositivo."
          >
            {env.problems.length > 0 && (
              <ul className="tarjeta__descripcion" role="alert" style={{ paddingLeft: '1.2em' }}>
                {env.problems.map((problema) => (
                  <li key={problema}>{problema}</li>
                ))}
              </ul>
            )}
            <p className="tarjeta__descripcion">
              Revisa <code>apps/app/.env</code> (Vite lo lee desde el directorio de la aplicación,
              no desde la raíz del repositorio) y reinicia el servidor de desarrollo. Sin esto
              puedes seguir usando la app en local, pero no habrá sincronización entre
              dispositivos.
            </p>
          </Tarjeta>
        </div>
      </div>
    );
  }

  return (
    <div className="entrada">
      <div className="entrada__caja">
        {/* Los tres trazos son el mismo signo que marca el area activa en la
            navegacion y encabeza la barra lateral. No hay logotipo y no se
            inventa uno: se repite lo que ya significa algo dentro del
            producto. */}
        <div className="entrada__marca">
          <span className="entrada__pulso" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          <div>
            <h1 className="entrada__nombre">Cadencia</h1>
            <p className="entrada__lema">
              Entrenador de fuerza, nutrición y seguimiento adaptativo.
            </p>
          </div>
        </div>

        <Tarjeta>
          <Boton
            ancho="completo"
            onClick={() => void signInWithGoogle()}
            cargando={status === 'loading'}
          >
            {status === 'loading' ? 'Comprobando sesión…' : 'Entrar con Google'}
          </Boton>
          {error !== null && (
            <p className="campo__error separado-poco" role="alert">
              {error}
            </p>
          )}
        </Tarjeta>

        {/*
          La explicacion de POR QUE hace falta una sesion sale de la tarjeta:
          dentro competia con el unico boton de la pantalla estando escrita en
          el mismo ancho y a dos lineas. Fuera y en tinta terciaria se lee
          despues, que es cuando hace falta.
        */}
        <p className="entrada__nota">
          La sesión es necesaria para sincronizar entre Android y Windows y para aislar tus datos.
        </p>

        {/* Se conserva el estado de carga anunciado para lectores de pantalla:
            el boton ya lo dice visualmente, pero `Estado` es quien lo publica
            por `role="status"`. */}
        {status === 'loading' && (
          <span className="visualmente-oculto">
            <Estado tipo="cargando" titulo="Comprobando sesión" />
          </span>
        )}
      </div>
    </div>
  );
}
